import { useContext } from 'react';
import InsightsFormStateContext from '../useFormState/form.state.context';
import { StyledConfigRow } from '../InsightsConfig.style';
import { INSIGHTS_KEYS } from '../../../insights.keys';
import InsightSwitch from '../Inputs/InsightSwitch';
import InputNumber from 'components/base/InputNumber';
import styled from 'styled-components';
import PmIssueStatesAutoComplete from 'components/PM/PmIssueStatesAutoComplete/PmIssueStatesAutoComplete';
import {
  PM_STATES_CATEGORIES_MAPPER,
  PM_STATES_TO_JIRA_STATES_MAPPER
} from 'modals/EditCustomPmMetricsModal/EditCustomPmMetricsModal.constants';
import usePmViewer from 'common/hooks/pm/usePmViewer';
import { capitalize } from 'lodash';

const StyledStuckIssuesInState = styled(StyledConfigRow)`
  & .MuiAutocomplete-root {
    margin: 0 1rem;
  }
`;

const StuckIssuesInState = () => {
  const { getInsight, updateInsight, onToggleSwitch } = useContext(
    InsightsFormStateContext
  );
  const pmViewer = usePmViewer();
  const issuesText = capitalize(pmViewer.ticket.plural);

  const insight = getInsight(INSIGHTS_KEYS.ISSUES_IN_STATE);
  const pmStateValue =
    insight.state || PM_STATES_TO_JIRA_STATES_MAPPER[insight.state_category];

  const onChangePmStatus = pmStatus => {
    const { isCategory } = pmStatus;
    const pmStatusCategory = isCategory
      ? pmStatus.value
      : pmStatus?.extra?.statusCategory?.key;
    const linbStatusCategory = PM_STATES_CATEGORIES_MAPPER[pmStatusCategory];

    const pmStatusValue = pmStatus.value;

    if (!linbStatusCategory || !pmStatusValue) return;

    updateInsight(insight.key, {
      state_category: linbStatusCategory,
      state: isCategory ? null : pmStatusValue
    });
  };

  return (
    <StyledStuckIssuesInState>
      <InsightSwitch insight={insight} onClick={onToggleSwitch} />
      {issuesText} stalled in state
      <PmIssueStatesAutoComplete
        value={pmStateValue}
        onChange={onChangePmStatus}
      />
      for
      <InputNumber
        value={insight.days}
        onChange={value =>
          updateInsight(insight.key, {
            days: value
          })
        }
      />
      days or more
    </StyledStuckIssuesInState>
  );
};

export default StuckIssuesInState;
